import { CustomDataTable } from 'components/customDataTable'
import { LoadingContainer } from 'components/loadingContainer'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { useDeleteDialog } from 'hooks/admin/useDeleteDialog'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import { Organization } from 'types/Organization'
import { TitleRowData } from 'types/TableHeader'

interface Props {
    configData: TitleRowData
    children: React.ReactNode
    handleEdit: (rowData: Organization) => void
}

export const OrganizationsTable: React.FC<Props> = ({ configData, children, handleEdit }) => {
    const { currentAccount, isLoadingCurrentAccount, errorCurrentAccount } = useCurrentAccount()
    const { show: showDeleteDialog, DialogComponent: DeleteDialog } = useDeleteDialog()

    const { data, isLoading, error, isDialogVisible, tableConfig, handleDelete, handleCloseDialog } = useOrganizations()

    return (
        <LoadingContainer isLoading={isLoading || isLoadingCurrentAccount} error={error || errorCurrentAccount}>
            {data && currentAccount && (
                <CustomDataTable
                    tableConfig={tableConfig}
                    currentAccount={currentAccount}
                    data={data}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    showDeleteDialog={showDeleteDialog}
                />
            )}
            {isDialogVisible && (
                <Dialog
                    header={configData.formConfig?.dialogProps?.header || 'Form'}
                    visible={isDialogVisible}
                    onHide={handleCloseDialog}
                    style={{ minWidth: '50vw', maxWidth: '60vw' }}
                    {...configData.formConfig?.dialogProps}
                    modal
                    closeOnEscape
                >
                    {React.cloneElement(children as React.ReactElement, { onClose: handleCloseDialog })}
                </Dialog>
            )}
            <DeleteDialog
                entityLabel={'a szervezetet'}
                cascadeWarning={'A törléssel minden hozzá kapcsolódó műsor, helyszín és esemény is törlésre kerül.'}
            />
        </LoadingContainer>
    )
}
